<app-back-header link='/home-versioner'></app-back-header>

<!-- Contenedor principal con dos columnas -->
<div class="min-h-screen flex flex-row p-4">

  <!-- Columna Izquierda: Artículo -->
  <div class="w-2/3 bg-white p-8 rounded-lg shadow mr-4">
    <h1 class="text-2xl not-italic font-bold leading-8 mb-6">Versionador de artículos</h1>

    <div *ngIf="versionData?.datos" class="space-y-6">
      <div class="flex flex-col">
        <label class="text-base text-dark-light">Título</label>
        <div class="mt-1 block w-full border-gray-300 rounded-md shadow-sm sm:text-sm bg-light-light p-4">
          {{ versionData?.datos?.titulo }}
        </div>
      </div>
    
      <div class="flex flex-col">
        <label class="text-base text-dark-light">Subtítulo</label>
        <div class="mt-1 block w-full border-gray-300 rounded-md shadow-sm sm:text-sm bg-light-light p-4">
          {{ versionData?.datos?.subtitulo }}
        </div>
      </div>
    
      <div class="flex flex-col">
        <label class="text-base text-dark-light">Cuerpo del texto</label>
        <div
          class="mt-1 block w-full border-gray-300 rounded-md shadow-sm sm:text-sm bg-light-light p-4 whitespace-pre-line">
          {{ versionData?.datos?.body }}
        </div>
      </div>
    
      
    </div>
    
  </div>

  <!-- Columna Derecha: Nuevo Prompt -->
    
  <div class="w-1/3 bg-white p-8 rounded-lg shadow">
    <form #promptForm="ngForm" (ngSubmit)="submitForm()" novalidate>
      <p class="font-bold text-lg">Selecciona el LLM para el nuevo prompt</p>

      <div class="flex flex-col gap-3 mt-6 mb-4" [ngClass]="{ 'border border-red-500 p-2 rounded': promptForm.submitted && !selectedIa }">
        <label *ngFor="let option of options" class="flex items-center gap-3 cursor-pointer">
          <input type="radio" name="iaOption" [value]="option.value" [(ngModel)]="selectedIa" required
            class="accent-blue-600 w-4 h-4" />
          <img [src]="option.image" class="w-28 h-8" />
        </label>
      </div>

      <div *ngIf="promptForm.submitted && !selectedIa" class="text-red-600 text-sm mb-4">
        Debes seleccionar una IA.
      </div>

      <h2 class="text-xl font-bold mb-4">Nuevo prompt</h2>
      <textarea name="prompt" [(ngModel)]="promptText" #promptTextRef="ngModel" required rows="6" class="w-full p-2 border border-gray-300 rounded-md mb-4 whitespace-pre-line"
       [ngClass]="{ 'border-red-500': promptForm.submitted && promptTextRef.invalid, 'border-gray-300': !(promptForm.submitted && promptTextRef.invalid) }"
        placeholder="Ingresa un nuevo prompt aquí..."></textarea>

        <div *ngIf="promptForm.submitted && promptTextRef.invalid" class="text-red-600 text-sm mb-4">
          El prompt no puede estar vacío.
        </div>

      <button type="submit" class="w-44 h-10 font-bold py-2 px-4 rounded-md hover:bg-green-700 bg-green-700 text-white">Enviar</button>
    </form>
  </div>
    
</div>